/**
 * Demo Feature Toggles
 * ─────────────────────────────────────────────
 * Quick toggles for hiding features during demos
 * Set to false to hide the feature
 */

export const DEMO_FEATURES = {
  // Hide multi-tenant switcher in header
  showTenantSwitcher: false,
  
  // Hide health score from dashboard and asset cards
  showHealthScore: false,
  
  // Keep AI diagnosis visible - core demo feature
  showAIDiagnosis: true,
} as const;
